import styled, { css } from 'styled-components';
import { ReactComponent as Arrow } from '../../../../assets/img/SimpleArrow.svg';

export const StyledArrow = styled(Arrow)`
  position: absolute;
  right: 0px;
  top: 5px;
  cursor: pointer;
`;

export const StyledRelativeContainer = styled.div`
  position: relative;
  width: 100%;
  transition: all 0.2s;
  ${({ isRightOpen }) => {
    if (isRightOpen) {
      return css`
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-right: 300px;
        transition: all 0.2s;
        @media screen and (max-width: 1199px) {
          margin-right: 0;
        }
      `;
    }
  }}
`;

export const StyledHeaderBlock = styled.aside`
  overflow: auto;
  position: fixed;
  left: 60px;
  right: 0;
  top: ${({ theme }) => theme.headerHeight};
  height: 35px;
  width: auto;
  transition: all 0.2s, opacity 0.3s;
  display: none;
  flex-direction: row;
  justify-content: center;
  z-index: 10;
  background: ${({ theme }) => theme.page};
  color: ${({ theme }) => theme.text};
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  border-top-left-radius: ${({ theme }) => theme.chromeRadius};
  h4 {
    margin-right: 20px;
  }
  ${({ showHeader }) =>
    showHeader &&
    css`
      display: flex;
    `}
  @media screen and (max-width: 1199px) {
    left: 0;
    right: 0;
    width: 100%;
    height: 44px;
    z-index: 3;
    border-top-right-radius: ${({ theme }) => theme.chromeRadius};
  }
  &[data-left='false'] {
    left: 60px;
    width: 270px;
    transform: translate3d(-100%, 0, 0);
    @media screen and (max-width: 1199px) {
      left: 0;
      width: 100%;
      transform: translate3d(-100%, 0, 0);
    }
  }
`;
